import ReactMarkdown from 'react-markdown';
import './MarkdownMessage.css';

interface MarkdownMessageProps {
  content: string;
  sender: 'user' | 'assistant';
}

export function MarkdownMessage({ content, sender }: MarkdownMessageProps) {
  // Clean up markdown formatting issues
  const compactContent = content
    // Collapse multiple consecutive newlines
    .replace(/\n{3,}/g, '\n\n')
    // Fix numbered lists with line break after number (e.g., "1. \nItem" -> "1. Item")
    .replace(/(\d+\.)\s*\n+/g, '$1 ')
    // Fix bullet lists with line break after bullet (e.g., "- \nItem" -> "- Item")
    .replace(/([-*])\s*\n+/g, '$1 ');

  return (
    <div className={`markdown-message ${sender}`}>
      <ReactMarkdown
        components={{
          // Customize rendering with compact spacing
          p: ({ children }) => <p style={{ margin: '0.2em 0' }}>{children}</p>,
          h1: ({ children }) => <h1 style={{ fontSize: '1.3em', marginTop: '0.4em', marginBottom: '0.2em', fontWeight: 'bold' }}>{children}</h1>,
          h2: ({ children }) => <h2 style={{ fontSize: '1.2em', marginTop: '0.4em', marginBottom: '0.2em', fontWeight: 'bold' }}>{children}</h2>,
          h3: ({ children }) => <h3 style={{ fontSize: '1.1em', marginTop: '0.3em', marginBottom: '0.15em', fontWeight: 'bold' }}>{children}</h3>,
          h4: ({ children }) => <h4 style={{ fontSize: '1em', marginTop: '0.3em', marginBottom: '0.1em', fontWeight: 'bold' }}>{children}</h4>,
          ul: ({ children }) => <ul style={{ marginLeft: '1.2em', marginTop: '0.2em', marginBottom: '0.2em', paddingLeft: '0.5em' }}>{children}</ul>,
          ol: ({ children }) => <ol style={{ marginLeft: '1.2em', marginTop: '0.2em', marginBottom: '0.2em', paddingLeft: '0.5em' }}>{children}</ol>,
          li: ({ children }) => <li style={{ marginBottom: '0.1em', lineHeight: '1.2' }}>{children}</li>,
          strong: ({ children }) => <strong style={{ fontWeight: 'bold' }}>{children}</strong>,
          hr: () => <hr style={{ margin: '0.5em 0', border: 'none', borderTop: '1px solid #ddd' }} />,
          code: ({ children }) => (
            <code
              style={{
                backgroundColor: '#f4f4f4',
                padding: '0.1em 0.3em',
                borderRadius: '3px',
                fontFamily: 'monospace',
                fontSize: '0.9em',
              }}
            >
              {children}
            </code>
          ),
          pre: ({ children }) => (
            <pre
              style={{
                backgroundColor: '#f4f4f4',
                padding: '0.5em',
                borderRadius: '5px',
                overflow: 'auto',
                marginTop: '0.3em',
                marginBottom: '0.3em',
                fontSize: '0.9em',
              }}
            >
              {children}
            </pre>
          ),
        }}
      >
        {compactContent}
      </ReactMarkdown>
    </div>
  );
}
